import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBars,
  faTimes,
  faHome,
  faInfoCircle,
  faEnvelope,
  faShieldAlt,
  faTachometerAlt,
  faSignOutAlt,
  faUserPlus,
  faSignInAlt,
} from '@fortawesome/free-solid-svg-icons';
import './Navbar.css';
import logo from '../Images/myapoti_logo_pot.png';
import AuthService from '../AuthService/AuthService';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ Check authentication status
  const checkAuth = () => {
    const access = localStorage.getItem('access_token');
    const refresh = localStorage.getItem('refresh_token');
    setIsLoggedIn(!!access && !!refresh);
  };

  // ✅ Check on mount and when localStorage changes
  useEffect(() => {
    checkAuth();

    // Listen for storage changes (works across tabs)
    window.addEventListener('storage', checkAuth);

    // Listen for custom auth events (works in same tab)
    window.addEventListener('authChange', checkAuth);

    return () => {
      window.removeEventListener('storage', checkAuth);
      window.removeEventListener('authChange', checkAuth);
    };
  }, []);

  // ✅ Periodic check (in case tokens are removed silently)
  useEffect(() => {
    const interval = setInterval(checkAuth, 1000);
    return () => clearInterval(interval);
  }, []);

  // ✅ Re-check on route change
  useEffect(() => {
    checkAuth();
  }, [location]);

  const toggleMenu = () => setIsMenuOpen((prev) => !prev);

  const handleLogout = () => {
    AuthService.clearTokens();
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    setIsLoggedIn(false);

    // Dispatch custom event to update other components
    window.dispatchEvent(new Event('authChange'));

    navigate('/');
    window.location.reload();
  };

  return (
    <nav className="myapoti-navbar">
      <div className="nav-content">
        <Link to="/Dashboard" className="nav-logo" onClick={() => setIsMenuOpen(false)}>
          <img src={logo} alt="MyApoti" />
        </Link>

        <div className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
          {!isLoggedIn && (
            <>
              <Link to="/" onClick={() => setIsMenuOpen(false)}>
                <FontAwesomeIcon icon={faHome} className="nav-icon" /> Home
              </Link>
              <Link to="/AboutUs" onClick={() => setIsMenuOpen(false)}>
                <FontAwesomeIcon icon={faInfoCircle} className="nav-icon" /> About Us
              </Link>
              <Link to="/signup" onClick={() => setIsMenuOpen(false)}>
                <FontAwesomeIcon icon={faUserPlus} className="nav-icon" /> Signup
              </Link>
              <Link to="/login" onClick={() => setIsMenuOpen(false)}>
                <FontAwesomeIcon icon={faSignInAlt} className="nav-icon" /> Login
              </Link>
            </>
          )}

          <Link to="/contact" onClick={() => setIsMenuOpen(false)}>
            <FontAwesomeIcon icon={faEnvelope} className="nav-icon" /> Contact
          </Link>
          <Link to="/PrivacyPolicy" onClick={() => setIsMenuOpen(false)}>
            <FontAwesomeIcon icon={faShieldAlt} className="nav-icon" /> Privacy Policy
          </Link>

          {isLoggedIn && (
            <>
              <Link to="/dashboard" onClick={() => setIsMenuOpen(false)}>
                <FontAwesomeIcon icon={faTachometerAlt} className="nav-icon" /> Dashboard
              </Link>
              <button className="logout-btn" onClick={handleLogout}>
                <FontAwesomeIcon icon={faSignOutAlt} className="nav-icon" /> Logout
              </button>
            </>
          )}
        </div>

        <div className="manual-toggle-icon" onClick={toggleMenu}>
          <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
